import axios from 'axios';

export const API_BASE = '/api';

const TOKEN_KEY = 'hf_cheques_token';
const EMPRESA_KEY = 'hf_cheques_empresa';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getEmpresa = () => {
  const raw = localStorage.getItem(EMPRESA_KEY);
  return raw ? JSON.parse(raw) : null;
};

export function guardarSesion(token, empresa) {
  localStorage.setItem(TOKEN_KEY, token);
  if (empresa) localStorage.setItem(EMPRESA_KEY, JSON.stringify(empresa));
}

export function cerrarSesion() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMPRESA_KEY);
}

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Token ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && getToken()) {
      cerrarSesion();
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

export async function login(email, password) {
  const res = await axios.post(`${API_BASE}/auth/login/`, { email, password });
  guardarSesion(res.data.token, res.data.empresa);
  return res.data;
}

export async function registrar(datos) {
  const res = await axios.post(`${API_BASE}/auth/register/`, datos);
  guardarSesion(res.data.token, res.data.empresa);
  return res.data;
}

export default api;
